import { BasicTable } from '../components/ReportTables/BasicTable';
import { FundIdentificationCodes } from '../components/ReportTables/FundIdentificationCodes';
import { BaseCurrency } from '../components/ReportTables/BaseCurrency';
import { FundSourceCode } from '../components/ReportTables/FundSourceCode';
import { ShareClasses } from '../components/ReportTables/ShareClasses';
import { InvestmentStrategies } from '../components/ReportTables/InvestmentStrategies';
import { FundStrategies } from '../components/ReportTables/FundStrategies';
import { PrimeBrokerFund } from '../components/ReportTables/PrimeBrokerFund';
import { MasterAifStatus } from '../components/ReportTables/MasterAifStatus';
import { MasterAIF } from '../components/ReportTables/MasterAIF';
import { MainInstruments } from '../components/ReportTables/MainInstruments';
import { GeographicalFocus } from '../components/ReportTables/GeographicalFocus';
import { PrincipalExposures } from '../components/ReportTables/PrincipalExposures';
import { MostImportPortfolio } from '../components/ReportTables/MostImportantPortfolio';
import { TypicalPositionSize } from '../components/ReportTables/TypicalPositionSize';
import { PrincipalMarkets } from '../components/ReportTables/PrincipalMarkets';
import { InvestorConcetration } from '../components/ReportTables/InvestorConcetration';
import { InvestorConcetration2 } from '../components/ReportTables/InvestorConcetration2';
import { IndividualExposures } from '../components/ReportTables/IndividualExposures';
import { Turnover } from '../components/ReportTables/Turnover';
import { CurrencyExposures } from '../components/ReportTables/CurrencyExposures';
import { DominantInfluences } from '../components/ReportTables/DominantInfluences';
import { MarketRiskProfile } from '../components/ReportTables/MarketRiskProfile';
import { MeasureRisk } from '../components/ReportTables/MeasureRisk';
import { ValueOfRisk } from '../components/ReportTables/ValueOfRisk';
import { Var } from '../components/ReportTables/Var';
import { Vega } from '../components/ReportTables/Vega';
import { Tranding } from '../components/ReportTables/Tranding';
import { ValueOfCollateral } from '../components/ReportTables/ValueOfCollateral';
import { CountriesCPP } from '../components/ReportTables/CountriesCPP';
import { CountriesMarket } from '../components/ReportTables/CountriesMarket';
import { ExposuresCPP } from '../components/ReportTables/ExposuresCPP';
import { LiquidityProfiles } from '../components/ReportTables/LiquidityProfiles';
import { LiquidityProfiles2 } from '../components/ReportTables/LiquidityProfiles2';
import { LiquidityRedemption } from '../components/ReportTables/LiquidityRedemption';
import { LiquidityRedemption2 } from '../components/ReportTables/LiquidityRedemption2';
import { Arragements } from '../components/ReportTables/Arragements';
import { Arragements2 } from '../components/ReportTables/Arragements2';
import { Treatment } from '../components/ReportTables/Treatment';
import { InvestmentGroup } from '../components/ReportTables/InvestmentGroup';
import { FinancingLiquidity } from '../components/ReportTables/FinancingLiquidity';
import { FinancingLiquidity2 } from '../components/ReportTables/FinancingLiquidity2';
import { FinancingLiquidity3 } from '../components/ReportTables/FinancingLiquidity3';
import { Borrowing } from '../components/ReportTables/Borrowing';
import { DerivativesExposure } from '../components/ReportTables/DerivativesExposure';
import { Leverage } from '../components/ReportTables/Leverage';
import { ControlledStucture } from '../components/ReportTables/ControlledStructure';
import { OpenPositions } from '../components/ReportTables/OpenPositions';
import { HistoricalProfile } from '../components/ReportTables/HistoricalProfile';
import { ResultStressTest } from '../components/ReportTables/ResultStressTest';
import { BorrowingSource } from '../components/ReportTables/BorrowingSource';
import { Assumptions } from '../components/ReportTables/Assumptions';
import { FundIdentificationCodesAIF001 } from '../components/ReportTables/FundIdentificationCodesAIF001';
import { BaseCurrencyAIF001 } from '../components/ReportTables/BaseCurrencyAIF001';
import { MostImportPortfolioAIF001 } from '../components/ReportTables/MostImportantPortfolioAIF001';
import { PrincipalInstruments } from '../components/ReportTables/PrincipalInstruments';
import { AssumptionsAIF001 } from '../components/ReportTables/AssumptionsAIF001';

export const strategyTableVariants = [
  {
    name: 'Hedge Fund Strategies',
    key: 'HEDGE_STRATEGIES'
  },
  {
    name: 'Private Equity Fund Strategies',
    key: 'PRIVATE_EQUITY_STRATEGIES'
  },
  {
    name: 'Real Estate Fund Strategies',
    key: 'REAL_ESTATE_STRATEGIES'
  },
  {
    name: 'Fund of Funds Strategies',
    key: 'FUND_OF_FUND_STRATEGIES'
  },
  {
    name: 'Other Fund Strategies',
    key: 'OTHER_FUND_STRATEGIES'
  }
];

export const tableSectionsAIF001 = [
  {
    key: 'MAIN_INFO',
    title: 'Main Info',
    sidebarName: '1-20: Main Info',
    condensed: '1',
    Component: FundIdentificationCodesAIF001
  },
  {
    key: 'AIFM_BASE_CURRENCY_DESCRIPTION',
    title:
      'Values of Assets under Management for All AIFs Managed, Calculated as Set out in Article 2 of the AIFMD Level 2 Regulation',
    sidebarName: '21-26: Values of Assets',
    condensed: '21',
    Component: BaseCurrencyAIF001
  },
  {
    key: 'AIFM_FIVE_PRINCIPAL_MARKET',
    title: 'Principal Markets in Which You Trade on Behalf of the AIFs You Manage',
    sidebarName: '27-31: Principal Markets in Which You Trade on Behalf of the AIFs You Manage',
    condensed: '27',
    Component: MostImportPortfolioAIF001
  },
  {
    key: 'AIFM_PRINCIPAL_INSTRUMENT',
    title: 'Principal Instruments in Which You Trade on Behalf of the AIFs You Manage',
    sidebarName: '32-36: Principal Instruments in Which You Trade on Behalf of the AIFs You Manage',
    condensed: '32',
    Component: PrincipalInstruments
  },
  {
    key: 'ASSUMPTIONS001',
    title: 'Assumptions',
    sidebarName: '37: Assumptions',
    condensed: '37',
    Component: AssumptionsAIF001,
    hasAddDelete: true
  }
];

export const tableSections = [
  {
    key: 'FUND_INFOS',
    title: 'Fund Infos',
    sidebarName: '1-5: Fund Infos',
    condensed: '1',
    Component: BasicTable
  },
  {
    key: 'FUND_ID_CODES',
    title: 'Fund Identification Codes',
    sidebarName: '6-26: Fund Identification Codes',
    condensed: '6',
    Component: FundIdentificationCodes
  },
  {
    key: 'BASE_CURRENCY_INFORMATION',
    title: 'Base Currency Information',
    sidebarName: '28-33: Base Currency Information',
    condensed: '28',
    Component: BaseCurrency
  },
  {
    key: 'FUNDING_SOURCE_COUNTRY_CODE',
    title: 'Jurisdictions of the Three Main Funding Sources',
    sidebarName: '39: Jurisdictions of the Three Main Funding Sources',
    condensed: '39',
    Component: FundSourceCode
  },
  {
    key: 'SHARE_CLASSES',
    title: 'Share Classes',
    sidebarName: '27: Share Classes',
    condensed: '27',
    Component: ShareClasses,
    hasAddDelete: true
  },
  {
    key: 'INVESTMENT_STRATEGIES',
    title: 'Investment Strategies of the Fund',
    sidebarName: '34-36: Investment Strategies of the Fund',
    condensed: '34',
    Component: InvestmentStrategies
  },
  ...strategyTableVariants.map(item => ({
    key: item.key,
    title: item.name,
    sidebarName: `37: ${item.name}`,
    condensed: '37',
    Component: function ({ ...restProps }) {
      return <FundStrategies tableKey={item.key} {...restProps} />;
    },
    hasAddDelete: true
  })),
  {
    key: 'PRIME_BROKE_FUNDS',
    title: 'Prime Broker',
    sidebarName: '38: Prime Broker',
    condensed: '38',
    Component: PrimeBrokerFund,
    hasAddDelete: true
  },
  {
    key: 'MASTER_AIF_STATUS',
    title: 'Master/Feeder Classification',
    sidebarName: '40: Master/Feeder Classification',
    condensed: '40',
    Component: MasterAifStatus
  },
  {
    key: 'MASTER_AIF',
    title: 'All master AIFs - if a feeder fund',
    sidebarName: '41: All master AIFs - if a feeder fund',
    condensed: '41',
    Component: MasterAIF,
    hasAddDelete: true
  },
  {
    key: 'MAIN_INSTRUMENTS',
    title: 'Main Instruments in Which the AIF Is Trading',
    sidebarName: '42-46: Main Instruments',
    condensed: '42',
    Component: MainInstruments,
    maxHeight: 'initial'
  },
  {
    key: 'GEOGRAPHICAL_FOCUS',
    title: 'Geographical Focus',
    sidebarName: '47-54: Geographical Focus',
    condensed: '47',
    Component: GeographicalFocus,
    maxHeight: 'initial'
  },
  {
    key: 'PRINCIPAL_EXPOSURES',
    title: 'Principal Exposures of the AIF at the Reporting Date',
    sidebarName: '55-64: Principal Exposures of the AIF at the Reporting Date',
    condensed: '55',
    Component: PrincipalExposures,
    maxHeight: 'initial'
  },
  {
    key: 'MOST_IMPORTANT_PORTFOLIO',
    title: 'Most Important Portfolio Concentrations',
    sidebarName: '65-69: Most Important Portfolio Concentrations',
    condensed: '65',
    Component: MostImportPortfolio,
    maxHeight: 'initial'
  },
  {
    key: 'TYPICAL_POSITION_SIZE',
    title: 'Typical Position Size',
    sidebarName: '70: Typical Position Size',
    condensed: '70',
    Component: TypicalPositionSize
  },
  {
    key: 'PRINCIPAL_MARKETS',
    title: 'Principal Markets in Which the AIF Trades',
    sidebarName: '71-73: Principal Markets',
    condensed: '71',
    Component: PrincipalMarkets,
    maxHeight: 'initial'
  },
  {
    key: 'INVESTOR_CONCENTRATION',
    title: 'Investor Concentration',
    sidebarName: '74: Investor Concentration',
    condensed: '74',
    Component: InvestorConcetration
  },
  {
    key: 'INVESTOR_CONCENTRATION2',
    title: 'Breakdown of investor concentration by status of investors:',
    sidebarName: '75-76: Breakdown of investor concentration by status of investors',
    condensed: '75',
    Component: InvestorConcetration2
  },
  {
    key: 'INDIVIDUAL_EXPOSURES',
    title: 'Individual exposures to assets in which the fund is trading',
    sidebarName: '77-147: Individual exposures',
    condensed: '77',
    Component: IndividualExposures,
    maxHeight: 'initial'
  },
  {
    key: 'TURNOVER',
    title: 'Value of Turnover',
    sidebarName: '148-175: Value of Turnover',
    condensed: '148',
    Component: Turnover,
    maxHeight: 'initial'
  },
  {
    key: 'CURRENCIES',
    title: 'Currency Exposures',
    sidebarName: '176: Currency Exposures',
    condensed: '176',
    Component: CurrencyExposures,
    hasAddDelete: true
  },
  {
    key: 'DOMINANT_INFLUENCES',
    title: 'Dominant Influences',
    sidebarName: '177: Dominant Influences',
    condensed: '177',
    Component: DominantInfluences,
    hasAddDelete: true
  },
  {
    key: 'MARKET_RISK_PROFILE',
    title: 'Market Risk Profile',
    sidebarName: '178: Market Risk Profile',
    condensed: '178',
    Component: MarketRiskProfile
  },
  {
    key: 'MARKET_RISK_MEASURE',
    title: 'Measures of risk',
    sidebarName: '179-181: Measures of risk',
    condensed: '179',
    Component: MeasureRisk
  },
  {
    key: 'VALUE_FOR_YEARS_RISK_MEASURE',
    title: 'Value of Risk',
    sidebarName: '182-183: Value of Risk',
    condensed: '182',
    Component: ValueOfRisk,
    maxHeight: 'initial'
  },
  {
    key: 'VAR_RISK_MEASURE',
    title: 'Var',
    sidebarName: '184: Var',
    condensed: '184',
    Component: Var
  },
  {
    key: 'VEGA_RISK_MEASURE',
    title: 'Vega',
    sidebarName: '185: Vega',
    condensed: '185',
    Component: Vega
  },
  {
    key: 'TRADING_CLEARING_DETAILS',
    title: 'Trading and clearing mechanisms',
    sidebarName: '186-189: Trading and clearing mechanisms',
    condensed: '186',
    Component: Tranding,
    maxHeight: 'initial'
  },
  {
    key: 'ALL_COUNTERPARTY_COLLATERAL',
    title: 'Value of collateral and other credit support',
    sidebarName:
      '190-192: Value of collateral and other credit support that the AIF has posted to all counterparties',
    condensed: '190',
    Component: ValueOfCollateral
  },
  {
    key: 'TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP',
    title: 'Top five counterparties (excluding CCPs)',
    sidebarName: '193-197: Top five counterparties (excluding CCPs)',
    condensed: '193',
    Component: CountriesCPP,
    maxHeight: 'initial'
  },
  {
    key: 'TOP_FIVE_COUNTRIES_COUNTERPARTY_EXPOSURE',
    title: 'Top five counterparties with greatest exposure',
    sidebarName:
      '198-202: Top five counterparties that have the greatest mark-to-market net counterparty credit exposure to the AIF',
    condensed: '198',
    Component: CountriesMarket,
    maxHeight: 'initial'
  },
  {
    key: 'CCP_EXPOSURE',
    title: 'Direct clearing through central clearing counterparties (CCPs)',
    sidebarName: '203-205: Direct clearing through central clearing counterparties (CCPs)',
    condensed: '203',
    Component: ExposuresCPP,
    maxHeight: 'initial'
  },
  {
    key: 'PORTFOLIO_LIQUIDITY_PROFILE',
    title: 'Liquidity Profiles',
    sidebarName: '206-207: Liquidity Profiles',
    condensed: '206',
    Component: LiquidityProfiles
  },
  {
    key: 'PORTFOLIO_LIQUIDITY_PROFILE2',
    Component: LiquidityProfiles2
  },
  {
    key: 'INVESTOR_LIQUIDITY_PROFILE',
    title: 'Potential investor redemption',
    sidebarName: '208-212: Potential investor redemption',
    condensed: '208',
    Component: LiquidityRedemption
  },
  {
    key: 'INVESTOR_LIQUIDITY_PROFILE2',
    Component: LiquidityRedemption2
  },
  {
    key: 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT',
    title: 'Special Arrangements and Preferential Treatment',
    sidebarName: '213-215: Special Arrangements and Preferential Treatment',
    condensed: '213',
    Component: Arragements
  },
  {
    key: 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT2',
    Component: Arragements2
  },
  {
    key: 'INVESTOR_PREFERENTIAL_TREATMENT',
    title: 'Treatment',
    sidebarName: '216-219: Treatment',
    condensed: '216',
    Component: Treatment
  },
  {
    key: 'INVESTOR_GROUP',
    title: 'Investor groups',
    sidebarName: '220: Investor groups',
    condensed: '220',
    Component: InvestmentGroup,
    hasAddDelete: true
  },
  {
    key: 'FINANCING_PROFILE',
    title: 'Financing liquidity',
    sidebarName: '221-224: Financing liquidity',
    condensed: '221',
    Component: FinancingLiquidity
  },
  {
    key: 'FINANCING_PROFILE2',
    Component: FinancingLiquidity2
  },
  {
    key: 'FINANCING_PROFILE3',
    Component: FinancingLiquidity3
  },
  {
    key: 'BORROWING_DETAILS',
    title: 'Borrowing and Exposure Risk',
    sidebarName: '225-228: Borrowing and Exposure Risk',
    condensed: '225',
    Component: Borrowing
  },
  {
    key: 'DERIVATIVE_EXPOSURE',
    title: 'Derivatives Exposure',
    sidebarName: '229-231: Derivatives Exposure',
    condensed: '229',
    Component: DerivativesExposure
  },
  {
    key: 'LEVERAGE_AIF',
    title: 'Leverage of the AIF',
    sidebarName: '233-234: Leverage of the AIF',
    condensed: '233',
    Component: Leverage
  },
  {
    key: 'CONTROLLED_STRUCTURE',
    title: 'Controlled Structure',
    sidebarName: '232: Gross exposure to financial',
    condensed: '232',
    Component: ControlledStucture,
    hasAddDelete: true
  },
  {
    key: 'OPEN_POSITIONS',
    title: 'Operational and Other Risk Aspects',
    sidebarName: '235: Operational and Other Risk Aspects',
    condensed: '235',
    Component: OpenPositions
  },
  {
    key: 'HISTORICAL_PROFILE',
    title: 'Historical Profile',
    sidebarName: '236-240: Historical Profile',
    condensed: '236',
    Component: HistoricalProfile,
    maxHeight: 'initial'
  },
  {
    key: 'RESULT_OF_STRESS_TESTS',
    title: 'Result Stress Test',
    sidebarName: '241-242: Result Stress Test',
    condensed: '241',
    Component: ResultStressTest
  },
  {
    key: 'BORROWING_SOURCE',
    title: 'FUND 3.4.5 R (Article 24(4) of AIFMD)',
    sidebarName: '243-255: FUND 3.4.5 R (Article 24(4) of AIFMD)',
    condensed: '243',
    Component: BorrowingSource
  },
  {
    key: 'ASSUMPTIONS',
    title: 'Assumptions',
    sidebarName: '256: Assumptions',
    condensed: '256',
    Component: Assumptions,
    hasAddDelete: true
  }
];

export const sections = tableSections.reduce((acc, item) => {
  if (item.sidebarName) {
    acc[item.key] = item.sidebarName;
  }
  return acc;
}, {});

export const condensedSections = tableSections.reduce((acc, item) => {
  if (item.condensed) {
    acc[item.key] = item.condensed;
  }
  return acc;
}, {});

const multipleTableNamesAIF002 = tableSections
  .filter(item => item.hasAddDelete)
  .reduce((acc, item) => {
    acc[item.key] = item.title;
    return acc;
  }, {});

const multipleTableNamesAIF001 = tableSectionsAIF001
  .filter(item => item.hasAddDelete)
  .reduce((acc, item) => {
    acc[item.key] = item.sidebarName;
    return acc;
  }, {});

export const MULTIPLE_TABLE_NAMES = {
  ...multipleTableNamesAIF002,
  ...multipleTableNamesAIF001
};

export const sectionsAIF001 = tableSectionsAIF001.reduce((acc, item) => {
  if (item.sidebarName) {
    acc[item.key] = item.sidebarName;
  }
  return acc;
}, {});

export const sectionsAIF001Condensed = tableSectionsAIF001.reduce((acc, item) => {
  if (item.condensed) {
    acc[item.key] = item.condensed;
  }
  return acc;
}, {});
